import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Greeting from "../pages/greeting/page";
import Facilities from "../pages/facilities/page";
import Privacy from "../pages/privacy/page";
import Refund from "../pages/refund/page";
import Directions from "../pages/directions/page";
import Nearby from "../pages/nearby/page";
import RoomsPage from "../pages/rooms/page";
import ReservationPage from "../pages/reservation/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/greeting",
    element: <Greeting />,
  },
  {
    path: "/facilities",
    element: <Facilities />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/refund",
    element: <Refund />,
  },
  {
    path: "/directions",
    element: <Directions />,
  },
  {
    path: "/nearby",
    element: <Nearby />,
  },
  {
    path: "/rooms",
    element: <RoomsPage />,
  },
  {
    path: "/reservation",
    element: <ReservationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
